// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607211204/js/" + chunkId + "." + {"44":"c6f4402f","225":"d7352f14","481":"4c380ff8","486":"262765c2","770":"bc117f3b"}[chunkId] + ".0.947310874260864.chunk.js";
};